import axios from 'axios';

export default {
  setDealers({commit}, isViewShort = false) {
    const param = isViewShort ? '?view=short' : ''
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/get-sub-dealers${param}`).then(res => {
        resolve(res.data);
        commit('updateDealers', res.data);
      }, error => {
        reject(error);
      })
    })
  },

  /**
   * Добавления опции с пустым значением
   * @param commit
   */
  addEmptyDealer({commit}) {
    commit('addEmptyDealer', {id: null, 'name': 'Все дилеры'});
  },

  setNotApprovedDealers({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/get-sub-dealers/not_approved`).then(res => {
        commit('updateNotApprovedDealers', res.data);
        resolve(res.data);
      }, error => {
        reject(error);
      })
    })
  },

  approveDealer({commit}, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/${uuid}/approve`).then(res => {
        resolve(res.data);
      }, error => {
        reject(error);
      })
    })
  },

  rejectDealer({commit}, {uuid, comment}) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/${uuid}/reject`, {
        'comment': comment
      }).then(res => {
        resolve(res.data);
      }, error => {
        reject(error);
      })
    })
  },

  deleteDealer({commit}, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`${process.env.VUE_APP_API_URL}/api/dealers/${id}`)
        .then(res => {
          resolve(res.data);
        }, error => {
          reject(error);
        })
    })
  },

  changeDealer({commit, rootGetters}, {data, index, save_and_approve = 0}) {
    return new Promise((resolve, reject) => {
      let item = {
        name: data.name,
        town: data.town,
        agent: data.contacts.agent,
        phone: data.contacts.phone,
        email: data.contacts.email,
        parent_dealer_employee_id: data.parent_dealer_employee_id,
        parent_dealer_addresses: data.parent_dealer_addresses,
        code_1c: data.code_1c,
        save_and_approve,
      };

      if (rootGetters['user/getDealerPricelist']) {
        item.is_own_pricelist_allowed = data.is_own_pricelist_allowed;
      }

      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/${data.uuid}/update`, item).then(res => {
        resolve(res.data);
        if (save_and_approve !== 1) {
          commit('updateDealer', data);
        }
      }, error => {
        reject(error);
      })
    })
  },
}
